// extracted by mini-css-extract-plugin
export default {"default":"TicketName-rebranding-module__default___1sDsP","disabled":"TicketName-rebranding-module__disabled___2EFF8"};